(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["widgets/calendar.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div id=\"calendarWidget\">\r\n    <div class=\"day\">";
output += runtime.suppressValue(env.getFilter("date").call(context, runtime.contextOrFrameLookup(context, frame, "now"),"j"), env.opts.autoescape);
output += "</div>\r\n    <div class=\"sum\">\r\n        <div class=\"day-abc\">";
output += runtime.suppressValue(env.getFilter("date").call(context, runtime.contextOrFrameLookup(context, frame, "now"),"l"), env.opts.autoescape);
output += "</div>\r\n        <div class=\"month\">";
output += runtime.suppressValue(env.getFilter("date").call(context, runtime.contextOrFrameLookup(context, frame, "now"),(runtime.contextOrFrameLookup(context, frame, "_lang") == "hu"?"Y. F":"F Y")), env.opts.autoescape);
output += "</div>\r\n    </div>\r\n</div>\r\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();
